module.exports = __webpack_public_path__ + "img/how-to-background.69b246e.png";